module.exports = __webpack_public_path__ + "static/img/surface3.82f1dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface3.png
// module id = xuuX
// module chunks = 2